import {TextField, TypographyProps} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

type HelpProps = TypographyProps & { isError?: boolean, displayWarning?: boolean, info?: boolean }

export const SectionHelpText = styled(Typography).withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) =>
        !['displayWarning'].includes(prop)
        && defaultValidatorFn(prop)
}).attrs({variant: 'caption'})`
  color: ${(props: HelpProps) => props.isError || props.displayWarning ? '#cc471d' : ''};
  font-size: ${(props: HelpProps) => props.isError || props.displayWarning ? '13px' : '14px'};
  margin-top: ${(props: HelpProps) => props.info ?  '4px' : '0'};

  span {
    display: block;
    margin-bottom: ${(props: HelpProps) => props.isError || props.displayWarning ?  '4px' : '0'};
  }
`;

export const ReadOnlyTextField = styled(TextField)`
  .MuiInputBase-input {
    color: #666c79;
  }

  .MuiInput-underline:before {
    border-bottom: none;
  }

  label + .MuiInput-formControl {
    margin-top: 34px;
  }
`

export const WarningText = styled.span`
  font-size: 14px;
  color: #000b1f;
`;
